import axios from 'axios';
// Get sudoku data via API
const ApiProvider = {
    getSudokuData: async (postId) => {
        const params = {
            action: 'get_sudoku_data',
            postId: postId,
        };
        const response = await axios
            // @ts-ignore
            .get(APP.ajax, { params });
        return response.data;
    }
};
export default ApiProvider;
